import React, { useImperativeHandle, useEffect, useState } from 'react';
import { Alert, Button, Transfer, Spin } from 'antd';
import useSearch from '../../gql/hooks/useSearch'; 
import './styles.less';

const FormCategories = ( { form, modifiedCallback, ref } ) => {
    const [ selectedCategories, setSelectedCategories ] = useState( [] );
    const { searchData, searchError, searchLoading, loadSearch } = useSearch( { type: 'categories' } );

    useImperativeHandle( ref, () => ( {
        reset() {
            form.setFieldsValue( { categoryIdsAreModified: false } ); 
            form.setFieldsValue( { categoryIdsModified: [] } ); 
            setSelectedCategories( form.getFieldValue( 'categoryIds' ) );
            modifiedCallback( false ); 
        }
    } ) );
            
    useEffect( () => loadSearch( { limit: 10000 } ), [] );
    
    useEffect( () => searchData && setSelectedCategories( form.getFieldValue( 'categoryIds' ) ), 
        [ searchData, setSelectedCategories ] );

    const handleCategoriesChange = ( values ) => {
        setSelectedCategories( values ); 
    
        // check is modifed 
        if ( JSON.stringify( values ) !== JSON.stringify( form.getFieldValue( 'categoryIds' ) ) ) {
            form.setFieldsValue( { categoryIdsAreModified: true } ); 
            form.setFieldsValue( { categoryIdsModified: values } ); 
            modifiedCallback( true );
        } else {
            form.setFieldsValue( { categoryIdsAreModified: false } ); 
            form.setFieldsValue( { categoryIdsModified: [] } ); 
            modifiedCallback( false );
        }
    };

    return (
        <div className="form-item-categories">
            
            { searchLoading && 
                <Spin />
            }
            
            { !searchLoading && searchError && 
                <Alert 
                    type="error"
                    message="Error"
                    description={
                        <>
                            <p>An unknown error occurred. Please try again later.</p>
                            <Button
                                onClick={ () => loadSearch( { limit: 10000 } ) }
                            >
                                Reload
                            </Button>
                        </>
                    }
                />
            }

            { !searchLoading && !searchError &&
                <>
                    <h4>Categories</h4>

                    <Transfer
                        dataSource={ searchData }
                        targetKeys={ selectedCategories }
                        showSearch
                        titles={ [ 'Available', 'Selected' ] }
                        onChange={ handleCategoriesChange }
                        render={ i => {
                            if ( i.name ) {
                                return i.name.length > 30 ? i.name.substring( 0, 30 ) + '...' : i.name;
                            } else {
                                return <span className='italic'>No Name</span>;
                            }  
                        } }
                        filterOption={ ( input, option ) => 
                            option.name.toLowerCase().includes( input.toLowerCase() )
                        }
                    />
                </>
            }
        </div>
    );
};

export default FormCategories;
